import React, { useEffect, useState } from 'react';
import styles from './EndNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import EndModal from './end-modal/EndModal';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
const EndNode = ({ id, data, selected }) => {
  const { workflowData, setWorkflowData, selectedNode } = useWorkflowContext();
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: false } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, []);

  return (
    <>
      <NodeContainer
        name={node?.title ?? 'End Block'}
        id={id}
        // onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        node={node}
      >
        <Handle
          type='target'
          position={Position.Left}
          className='custom-handle'
        />
        <div className={styles.cont}>
          <div className={styles.details}>
            {' '}
            <SvgWithBranding type='node-end' color='#787878' />
            <p>End</p>
          </div>

          <div className={styles.text}>
            <p className={styles.placeholder}>
              {' '}
              {data?.trigger == undefined
                ? 'End block ends the agent in its current state'
                : data?.trigger == '1'
                ? `Keyword: ${data?.keyword}`
                : 'Idle for 5 minutes'}
            </p>
          </div>
        </div>

        {/* <Handle
          type="source"
          position={Position.Right}
          className="custom-handle"
        /> */}
      </NodeContainer>
      <EndModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Capture'
        id={id}
      />
    </>
  );
};

export default EndNode;
